export default __webpack_public_path__ + "static/media/stopDrop.947d120d.png";